import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import schematicTreeData from '../../../../services/Sierra/schematicTree/schematicTreeData';
import { getSchematicCompColor, SchematicPlot, ConnectionPlot, getInterfaceSetupInfo } from '../../../../services/Sierra/schematicTree';
import { COMP_REPEATER, CONNECTOR, DIODE, IC, JUMPER, RLC_TYPES } from '../../../../services/PCBHelper';
import { Select, Tooltip } from 'antd';
import { getSchematicViewData, refreshSchematicViewData, updateSchematicViewPcbStatus, updateSchematicConfig } from '../../store/sierra/action';
import { LoadingOutlined, FileTextOutlined, RedoOutlined, CameraOutlined, EyeOutlined } from '@ant-design/icons'
import MsgDialogPanel from '../../../../components/MsgDialog/msgPanel';
import _ from 'lodash';
import { formatRLCValue } from '../../../../services/RLCModel';
import { getTextWidth } from '../../../../services/helper/getTextWidth';
import multiPCBConnections from '../../../../services/Sierra/schematicTree/multiPCBConnections';
import { downloadFile } from '../../../../services/helper/downloadHelper';
import { selectChange, changeDisplaySelected, selectLayer, changeShowNameStatus } from '../../../LayoutExplorer/store/Sierra/actionCreators';
import html2canvas from 'html2canvas';
import canvas from '@/services/LayoutCanvas';
import { getSelectedDesignIDs } from '../../../../services/helper/dataProcess';
import { NetGroupSelection } from '@/services/PCBHelper';
import designConstructor from '../../../../services/helper/designConstructor';
import './index.css'

class SchematicTree extends Component {

  constructor(props) {
    super(props);
    let loading = {}
    if (props.Interfaces.length) {

      for (let info of props.Interfaces) {
        if (designConstructor.isPreLayout(info.pcbId)) {
          continue;
        }
        loading[info.pcbId] = true;
      }
    }
    this.state = {
      loading,
      logDisplayId: null,
      pcbRoots: {},
      shot: null
    }
    this.netGroupSelection = new NetGroupSelection();
    this.schematicList = {}
  }

  componentDidMount = async () => {
    const { schematicViewPcbList, schematicViewErrorList } = this.props;
    if (schematicViewPcbList && schematicViewPcbList.length) {
      this.initPlot(schematicViewPcbList)
    };

    if (schematicViewErrorList && schematicViewErrorList.length) {
      let loading = this.state.loading;
      for (let pcbId of schematicViewErrorList) {
        loading[pcbId] = false;
      }
      this.setState({
        loading
      })
    }

    this.getConnections()
  }

  componentDidUpdate = (prevProps) => {
    const { Interfaces, schematicViewPcbList, schematicViewErrorList } = this.props;
    if (/* verificationId !== prevProps.verificationId
      || */ (!prevProps.Interfaces && Interfaces && Interfaces.length)
      || (prevProps.Interfaces && Interfaces && Interfaces.length !== prevProps.Interfaces.length)
      || (prevProps.Interfaces && Interfaces && !_.isEqual(Interfaces.map(item => item.interfaceId), prevProps.Interfaces.map(item => item.interfaceId)))
      || (!_.isEqual(prevProps.Interfaces || [], Interfaces || []))) {
      this.initData()
      this.getConnections()
    }

    if (!_.isEqual(schematicViewPcbList || [], prevProps.schematicViewPcbList || []) && schematicViewPcbList && schematicViewPcbList.length) {
      const newPcbList = schematicViewPcbList.filter(pcbId => !prevProps.schematicViewPcbList.includes(pcbId));
      this.initPlot(newPcbList)
    }

    if (!_.isEqual(schematicViewErrorList || [], prevProps.schematicViewErrorList || []) && schematicViewErrorList && schematicViewErrorList.length) {
      const newPcbList = schematicViewErrorList.filter(pcbId => !prevProps.schematicViewErrorList.includes(pcbId));
      let loading = this.state.loading;
      for (let pcbId of newPcbList) {
        loading[pcbId] = false;
      }
      this.setState({
        loading
      })
    }

  }

  initData = () => {
    const { Interfaces, verificationId, compPrefixLibInfo, compPinMap } = this.props;
    if (Interfaces.length) {
      let loading = {}
      for (let info of Interfaces) {
        if (designConstructor.isPreLayout(info.pcbId)) {
          continue;
        }
        loading[info.pcbId] = true;
        this.schematicList = {}
      }
      this.setState({
        loading
      }, () => {
        this.props._getSchematicViewData(verificationId, { compPrefixLibInfo, compPinMap })
      })
    }
  }

  getConnections = () => {
    const { Interfaces, verificationId } = this.props;
    let pcbConnection = null;
    this.setState({
      showConnections: false
    })
    if (Interfaces.length < 2) {
      return
    }
    const findConn = Interfaces.find(info => info.content && info.content.components && info.content.components.find(comp => comp.type === CONNECTOR && comp.connect && comp.connect.pcbId))
    if (!findConn) {
      return
    }
    this.setState({
      showConnections: true
    }, () => {
      setTimeout(() => {
        try {
          //init multi pcb connections
          pcbConnection = multiPCBConnections.get(verificationId);
          const interfaceSetup = multiPCBConnections.getSetup(verificationId);
          const newInterfaceSetup = Interfaces.map(item => getInterfaceSetupInfo(item));
          if (!pcbConnection || !_.isEqual(interfaceSetup || [], newInterfaceSetup)) {
            multiPCBConnections.getPCBConnections(verificationId, Interfaces);
          }
          pcbConnection = multiPCBConnections.get(verificationId);
          this.setState({
            pcbConnection
          })

          this.connectorSchematic = new ConnectionPlot({
            id: `sierra-setup-connection-schematic-canvas`,
            width: pcbConnection.bounds.width || 800,
            height: pcbConnection.bounds.height || 400,
            paths: pcbConnection.paths || [],
            unitSize: pcbConnection.bounds.unitSize || 40,
            font: 12
          });
          this.connectorSchematic.clear();
          this.connectorSchematic.draw();

        } catch (error) {
          console.error(error)
        }
      }, 500)
    })
  }

  initPlot = (newPcbList = []) => {
    const { Interfaces, verificationId, schematicDrawPCBLogs, schematicConfig } = this.props;
    const { loading, pcbRoots } = this.state;
    let _loading = { ...loading }, _pcbRoots = { ...pcbRoots }, _schematicDrawPCBLogs = { ...schematicDrawPCBLogs };
    for (let info of Interfaces) {
      if (!newPcbList.includes(info.pcbId) || designConstructor.isPreLayout(info.pcbId)) {
        continue;
      }
      const { pcbId, content } = info;
      _schematicDrawPCBLogs[pcbId] = [{ id: "schematic draw", log: "==> Starting to draw the schematic diagram..." }];

      const tree = schematicTreeData.getData(verificationId, pcbId) || {};
      const bounds = tree.bounds || {};
      const roots = tree.roots || [];
      const visibleSignals = schematicConfig.visibleSignals || [];
      const currVisibleSignals = visibleSignals.find(it => it.pcbId === pcbId);
      const _visibleSignals = currVisibleSignals && currVisibleSignals.signals ? currVisibleSignals.signals : (content.signals || []).map(item => item.name);

      const schematic = new SchematicPlot({
        id: `sierra-setup-schematic-canvas-${pcbId}`,
        width: bounds.width || 800,
        height: bounds.height || 400,
        data: tree.layoutPaths || [],
        nodes: tree.nodes || new Map(),
        unitSize: tree.unitSize || 40,
        font: 14,
        signals: content.signals || [],
        netsMaxLength: tree.netsMaxLength || {},
        unusedCompNodes: tree.unusedCompNodes || new Map(),
        visibleSignals: _visibleSignals
      });
      schematic.clear();
      schematic.draw();
      this.schematicList[pcbId] = schematic;
      _loading[pcbId] = false;
      _pcbRoots[pcbId] = roots;
      _schematicDrawPCBLogs[pcbId].push({ id: "schematic draw", log: "==> Drawing the schematic diagram has been completed." });
    }
    this.setState({
      loading: { ..._loading },
      pcbRoots: { ..._pcbRoots }
    })
    this.props._updateSchematicViewPcbStatus({ schematicDrawPCBLogs: _schematicDrawPCBLogs });
  }

  getRLCCompType = (compItem) => {

    if (![COMP_REPEATER, IC, CONNECTOR].includes(compItem.type) && ((compItem.pins || []).find(it => !it.signal) || compItem.pins.length === 1)) {
      return "parallel"
    }
    if (!RLC_TYPES.includes(compItem.type) || (RLC_TYPES.includes(compItem.type) && compItem.pins.filter(it => it.signal).length > 2)) {
      return "";
    }
    if (((compItem.pins || []).find(it => !it.signal) || compItem.pins.length === 1)) {
      return "parallel"
    }
    return "series"
  }

  openLog = (e, pcbId, pcbName) => {
    e && e.stopPropagation()
    this.setState({
      logDisplayId: { pcbId, pcbName }
    })
  }
  closeLogPanel = () => {
    this.setState({
      logDisplayId: null
    })
  }

  changeRootSelect = (values, pcbId) => {
    this.setState({
      pcbRoots: { ...this.state.pcbRoots, [pcbId]: values }
    })
  }

  refreshSchematic = (e, pcbId) => {
    e && e.stopPropagation();
    const { pcbRoots } = this.state;
    this.setState({
      loading: { ...this.state.loading, [pcbId]: true }
    }, () => {
      this.props._refreshSchematicViewData(this.props.verificationId, pcbId, pcbRoots[pcbId])
    })
  }

  getComponentSize = ({ compItem, unitSize, rlcType }) => {
    const { x, y, width, height } = compItem;
    if (["parallel", "series"].includes(rlcType)) {
      /* if (compItem.isY) {
        return {
          x: (x - 0.23) * unitSize,
          y: y * unitSize,
          width: width * unitSize,
          height: height * unitSize
        }
      } */
      return {
        x: x * unitSize,
        y: y * unitSize,
        width: width * unitSize,
        height: height * unitSize
      }
    }
    return {
      x: (x + 0.5) * unitSize,
      y: y * unitSize,
      width: (width - 1) * unitSize,
      height: height * unitSize
    }
  }

  getComponentPinSize = ({ compItem, unitSize, rlcType, pin }) => {
    let pinX = pin.x === compItem.x ? pin.x - compItem.x - 0.5 : pin.x - compItem.x - 1;
    let pinY = (pin.y - compItem.y);

    let pinDir = pin.x === compItem.x ? "left" : "right";
    if (pin.x !== compItem.x && pin.x !== compItem.x + compItem.width) {
      pinDir = "center"
    }

    if (rlcType === "series") {
      /* if (compItem.isY) {
        pinDir = pin.y === compItem.y + 0.23 ? "top" : "bottom"
  
        return {
          pinX: 0,
          pinY: pin.y === compItem.y + 0.23 ? 0 : 2 * unitSize - 26,
          pinDir
        }
      } */
      return {
        pinX: pin.x === compItem.x ? 0 : (pin.x - compItem.x - 0.5) * unitSize - 2,
        pinY: 0,
        pinDir
      }
    }

    return {
      pinX: pinX * unitSize - 2,
      pinY: pinY * unitSize - 12,
      pinDir
    }
  }

  getComponentDisplay = (compItem, name, rlcType, components) => {
    let compDisplay = name;
    const comp = components.find(it => it.name === name) || {};
    const { valueText, singleValue } = formatRLCValue(compItem.type, comp.value, comp.model, "", true)
    if (rlcType === "parallel") {
      const powerNet = ((comp.pins || []).find(it => !it.signal) || {}).net;
      return { compDisplay: singleValue, singleValue, powerNet, valueText: singleValue !== valueText ? valueText : "" }
    }
    return { compDisplay, singleValue, valueText: singleValue !== valueText ? valueText : "" };
  }

  getSchematicTreeItem = (tree, components) => {
    const layoutComps = tree.layoutComps || new Map();
    const unitSize = tree.unitSize || 40;
    const parallelComps = tree.parallelComps || [];

    return (
      <Fragment>
        {Array.from(layoutComps.keys()).map((_comp) => {
          const [comp, compIndex] = _comp.split("::");
          if (parallelComps.includes(comp)) {
            return null;
          }
          const compItem = layoutComps.get(_comp) || {};

          const rlcType = this.getRLCCompType(compItem);
          const pullUpRLCClass = rlcType === "parallel" ? 'sierra-schematic-tree-RLC-comp-item' : '';
          const seriesRLCClass = rlcType === "series" ? 'sierra-schematic-tree-RLC-series-comp-item' : '';
          const seriesYClassName = /* compItem.isY ? 'sierra-schematic-tree-RLC-series-y-comp-item' : */'';
          const { x, y, width, height } = this.getComponentSize({ compItem, unitSize, rlcType });
          const color = getSchematicCompColor(compItem.type);
          const { compDisplay, singleValue, powerNet, valueText } = this.getComponentDisplay(compItem, comp, rlcType, components);
          const powerWidth = powerNet ? getTextWidth(powerNet, 12, null, 500) : 0;
          return <div
            key={_comp}
            className={`sierra-schematic-tree-comp-item ${pullUpRLCClass} ${seriesRLCClass} ${seriesYClassName}`}
            style={{
              left: x,
              top: y,
              width,
              height,
              backgroundColor: rlcType !== "series" ? color : "#fff"
            }}
          >
            <Tooltip
              title={valueText || singleValue ? valueText || singleValue : ""}
              classNames={{ root: "aurora-tooltip" }}
            >
              <div className='sierra-schematic-tree-comp-name'>{compDisplay}</div>
            </Tooltip>
            {!pullUpRLCClass ? (compItem.pins || []).map((pin) => {
              const { pinX, pinY, pinDir, } = this.getComponentPinSize({ compItem, unitSize, rlcType, pin })
              return <div
                key={`${comp}-${pin.pin}`}
                className={`sierra-schematic-tree-comp-pin sierra-schematic-tree-comp-${pinDir}-pin sierra-schematic-tree-comp-${rlcType}-pin`}
                style={{
                  left: pinX,
                  top: pinY,
                  backgroundColor: rlcType === "series" ? color : null
                }}

              >{pin.pin}</div>
            }) : null}
            {/* name and pull up/down net */}
            {rlcType === "parallel" ? <div>
              <div className='sierra-schematic-tree-comp-parallel-name'>{comp}</div>
              <div className='sierra-schematic-tree-comp-parallel-power-net'
                style={{ left: -(powerWidth / 2) + 11.5 }}
              >{powerNet}</div>
            </div> : null}
          </div>
        })}
      </Fragment>
    )
  }

  printSchematic = (e, interfaceId, pcb) => {
    this.setState({
      shot: interfaceId
    }, () => {
      setTimeout(() => {
        const ele = document.getElementById(`schematic-tree-item-${interfaceId}`);
        if (!ele) {
          return
        }
        const config = {
          width: ele.scrollWidth,
          windowWidth: ele.scrollWidth + 20,
          scale: 1
        }
        html2canvas(ele, config).then(canvas => {
          downloadFile(canvas, `${pcb}-schematic.png`, 'canvas');
        })
        this.setState({
          shot: null
        })
      }, 500)
    })
  }

  viewLayout = (e, pcbId) => {
    e && e.stopPropagation()
    const { Interfaces, selectedDesignIDs } = this.props;
    if (!selectedDesignIDs.includes(pcbId)) {
      return
    }
    const currentInterface = Interfaces.find(item => item.pcbId === pcbId);
    const { components = [], signals = [] } = currentInterface.content;
    const signalNets = signals.map(item => item.nets).flat(2);
    const { pinsObj, comps, layers, resComp } = this.getSelectData({ pcbId, components, signalNets })
    this.props._selectLayer(layers, pcbId);
    this.props._selectChange({ pinsObj, comps, nets: [...signalNets] }, pcbId);
    this.props.changeDisplaySelected(true, pcbId)
    this.props._changeShowNameStatus(true, pcbId)
    setTimeout(() => {
      this.netGroupSelection.selectNetGroup({ pinsObj, comps, nets: [...signalNets], pcbId, resComp })
    }, 800);

  }

  getSelectData = ({ pcbId, components, signalNets }) => {
    let pinsObj = {}, comps = [], resComp = [];

    for (let comp of components) {
      const { type, pins, name } = comp
      if ([...RLC_TYPES, JUMPER, DIODE].includes(type)) {
        const filterNets = pins.filter(item => signalNets.includes(item.net))
        if (filterNets.length) {
          // add connect select signal net comp
          comps.push(name);
          resComp.push(name)
        }

        const filterPin = pins.filter(item => signalNets.includes(item.net));
        if (filterPin && filterPin.length && pins.length > 2) {
          pinsObj[name] = filterPin.map(item => item.pin)
        }
      } else {
        const filterPin = pins.filter(item => signalNets.includes(item.net));
        if (filterPin.length) {
          pinsObj[name] = filterPin.map(item => item.pin)
          comps.push(name)
        }
      }
    }
    comps = [...new Set(comps)];
    const layout = canvas.getLayout(pcbId);
    let layers = layout && layout.findCurrentLayer ? layout.findCurrentLayer(comps) : [];
    layers = [...new Set(layers)];
    // get layers
    return { pinsObj, comps, layers, resComp }
  }

  changeSignalsSelect = (value, pcbId) => {
    const { verificationId, schematicConfig } = this.props;
    let visibleSignals = schematicConfig.visibleSignals || [];
    const index = visibleSignals.findIndex(it => it.pcbId === pcbId);
    if (index < 0) {
      visibleSignals.push({
        pcbId,
        signals: value
      })
    } else {
      visibleSignals[index].signals = value;
    }
    schematicConfig.visibleSignals = visibleSignals;
    this.props._updateSchematicConfig(schematicConfig, verificationId);
    schematicTreeData.updateSchematicTree({ id: verificationId, signals: value, pcbId })
    setTimeout(() => {
      this.initPlot([pcbId])
    }, 60)
  }

  render() {
    const { Interfaces, verificationId, schematicViewPCBLogs, schematicDrawPCBLogs, selectedDesignIDs, schematicConfig } = this.props;
    const { loading, logDisplayId, pcbRoots, showConnections, shot } = this.state;
    const _Interfaces = Interfaces.filter(item => !designConstructor.isPreLayout(item.pcbId));
    const visibleSignals = schematicConfig.visibleSignals || [];

    return (
      <Fragment> <div className='sierra-schematic-tree'>
        {showConnections ? this.connectorSchematicRender() : null}
        {_Interfaces.map(contentItem => {
          const tree = schematicTreeData.getData(verificationId, contentItem.pcbId) || {};
          const bounds = tree.bounds || {};
          const components = contentItem.content ? contentItem.content.components || [] : [];
          const lengthUnit = tree.treeData ? tree.treeData.lengthUnit : "";
          const signals = contentItem.content ? contentItem.content.signals || [] : [];
          const findVisible = visibleSignals.find(it => it.pcbId === contentItem.pcbId);
          const selectedSignals = findVisible ? findVisible.signals : signals.map(item => item.name);
          return <div
            key={contentItem.interfaceId}
            className='sierra-schematic-tree-item'
            id={`schematic-tree-item-${contentItem.interfaceId}`}
            style={{
              // width: (bounds.width || 800) + 20,
              //  height: (bounds.height || 400) + 66,
            }}>
            <div className='sierra-schematic-tree-item-title'>
              <div className='sierra-schematic-tree-item-title-pcb'>{contentItem.pcb}</div>
              {loading[contentItem.pcbId] ? <div className='sierra-schematic-tree-item-title-icon'><LoadingOutlined /></div>
                : <div className='sierra-schematic-tree-item-title-icon'>
                  <Tooltip title="Refresh Schematic" classNames={{ root: "aurora-tooltip" }}>
                    <RedoOutlined
                      onClick={(e) => this.refreshSchematic(e, contentItem.pcbId)}
                    />
                  </Tooltip>
                </div>}
              <div className='sierra-schematic-tree-item-title-icon'>
                <Tooltip title="Schematic Creation Log" classNames={{ root: "aurora-tooltip" }}>
                  <FileTextOutlined
                    onClick={(e) => this.openLog(e, contentItem.pcbId, contentItem.pcb)}
                  />
                </Tooltip>
              </div>
              <div className='sierra-schematic-tree-item-title-icon sierra-schematic-photo-box'>
                <Tooltip title={shot === contentItem.interfaceId ? "Saving screenshot..." : "Screenshot"} classNames={{ root: "aurora-tooltip" }}>
                  {shot === contentItem.interfaceId ? <LoadingOutlined /> : <CameraOutlined
                    className='sierra-schematic-photo'
                    onClick={(e) => this.printSchematic(e, contentItem.interfaceId, contentItem.pcb)} />}
                </Tooltip>
              </div>
              <div
                className={selectedDesignIDs.includes(contentItem.pcbId) ? 'sierra-schematic-tree-item-title-icon' : 'sierra-schematic-tree-item-title-icon sierra-schematic-view-layout-disabled'}>
                <Tooltip title={selectedDesignIDs.includes(contentItem.pcbId) ? "View In Layout" : "Please Open PCB Layout"} classNames={{ root: "aurora-tooltip" }}>
                  <EyeOutlined
                    onClick={(e) => this.viewLayout(e, contentItem.pcbId)} />
                </Tooltip>
              </div>
              <div className='sierra-schematic-tree-item-title-root-content'>
                <span>Root Components</span>
                <Select
                  onChange={(value) => this.changeRootSelect(value, contentItem.pcbId)}
                  value={pcbRoots[contentItem.pcbId] || []}
                  mode="multiple"
                  className='sierra-schematic-tree-item-title-root-select aurora-select aurora-select-multiple'
                  classNames={{ popup: { root: 'aurora-select-dropdown' } }}
                  options={components.filter(item => [IC, CONNECTOR].includes(item.type)).map(item => ({ value: item.name, label: item.name, title: item.name }))}
                />
              </div>
              <div className='sierra-schematic-tree-item-title-length-unit-content'>
                <span>Length Unit:</span>
                <span className='sierra-schematic-tree-item-title-length-unit'>{lengthUnit}</span>
              </div>
              <div className='sierra-schematic-tree-item-title-root-content sierra-schematic-tree-item-title-signals-content'>
                <span>Visible signals</span>
                <Select
                  onChange={(value) => this.changeSignalsSelect(value, contentItem.pcbId)}
                  value={selectedSignals || []}
                  mode="multiple"
                  maxTagCount={"responsive"}
                  popupMatchSelectWidth={false}
                  className='sierra-schematic-tree-item-title-signals-select aurora-select aurora-select-multiple'
                  classNames={{ popup: { root: 'aurora-select-dropdown' } }}
                  options={signals.map(item => ({ value: item.name, label: item.name, title: item.name }))}
                />
              </div>
            </div>
            {/* <Spin spinning={loading[contentItem.pcbId] || false}> */}
            <div className='sierra-schematic-tree-item-content'>
              {this.getSchematicTreeItem(tree, components)}
              <div className='sierra-schematic-tree-item-connection-canvas'>
                <canvas
                  className='sierra-schematic-tree-item-canvas'
                  id={`sierra-setup-schematic-canvas-${contentItem.pcbId}`}
                  width={bounds.width || 800}
                  height={bounds.height || 400}
                />
              </div>
            </div>
            {/*  </Spin> */}
          </div>
        })}
      </div>
        {
          logDisplayId && logDisplayId.pcbId ? <MsgDialogPanel
            type="info"
            title={`${logDisplayId.pcbName} Schematic Log`}
            className="sierra-panel"
            allowDownload={true}
            getMessageList={() => this.getMessageList(schematicViewPCBLogs, schematicDrawPCBLogs, logDisplayId)}
            fileName={logDisplayId.pcbName ? `${logDisplayId.pcbName}_schematic.log` : "schematic.log"}
            closePanel={this.closeLogPanel}
          /> : null
        }
      </Fragment >
    )
  }

  getMessageList = (schematicViewPCBLogs, schematicDrawPCBLogs, logDisplayId) => {
    const pcbLogs = schematicViewPCBLogs && schematicViewPCBLogs[logDisplayId.pcbId] && schematicViewPCBLogs[logDisplayId.pcbId].log
      ? schematicViewPCBLogs[logDisplayId.pcbId].log.map(item => item.log)
      : [];
    const drawLogs = schematicDrawPCBLogs && schematicDrawPCBLogs[logDisplayId.pcbId]
      ? schematicDrawPCBLogs[logDisplayId.pcbId].map(item => item.log) : [];
    return [...pcbLogs, ...drawLogs]
  }


  connectorSchematicRender = () => {
    const { pcbConnection, shot } = this.state;
    const width = pcbConnection && pcbConnection.bounds ? pcbConnection.bounds.width || 800 : 800,
      height = pcbConnection && pcbConnection.bounds ? pcbConnection.bounds.height || 400 : 400;
    return <div className='sierra-schematic-tree-item'
      id="schematic-tree-item-pcb-connections"
      style={{
        width: (width || 800) + 20,
        height: (height || 400) + 66,
      }}>
      <div className='sierra-schematic-tree-item-title'>
        <div className='sierra-schematic-tree-item-title-pcb'>PCB Connections</div>
        <div className='sierra-schematic-tree-item-title-icon sierra-schematic-photo-box'>
          <Tooltip title={shot === "pcb-connections" ? "Saving screenshot..." : "Screenshot"} classNames={{ root: "aurora-tooltip" }}>
            {shot === "pcb-connections" ? <LoadingOutlined />
              : <CameraOutlined
                className='sierra-schematic-photo'
                onClick={(e) => this.printSchematic(e, "pcb-connections", "PCB-Connections")} />}
          </Tooltip>
        </div>
      </div>
      <div className='sierra-schematic-tree-item-content'>
        {this.getSchematicConnItem(pcbConnection)}
        <div className='sierra-schematic-tree-item-connection-canvas'>
          <canvas
            className='sierra-schematic-tree-item-canvas'
            id="sierra-setup-connection-schematic-canvas"
            width={width}
            height={height}
          />
        </div>
      </div>

    </div>
  }

  getSchematicConnItem = (pcbConnection) => {
    if (!pcbConnection) {
      return;
    }
    const connections = pcbConnection.connections || new Map();
    const unitSize = pcbConnection.bounds.unitSize || 40;

    return (
      <Fragment>
        {Object.keys(pcbConnection.pcbs).map((pcbId) => {
          const pcbItem = pcbConnection.pcbs[pcbId] || {};
          return (
            <div
              key={pcbId}
              className='sierra-schematic-tree-pcb-item'
              style={{
                left: pcbItem.x * unitSize,
                top: pcbItem.y * unitSize,
                width: pcbItem.width * unitSize,
                height: pcbItem.height * unitSize,
                backgroundColor: pcbItem.color
              }}>
              <div className='sierra-schematic-tree-pcb-name' title={pcbItem.name}>{pcbItem.name}</div>
            </div>
          )
        })}
        {Array.from(connections.keys()).map((comp, index) => {
          const compItem = connections.get(comp) || {};
          const [pcbId, compName] = comp.split('::');
          const { x, y, width, height } = compItem;
          const color = getSchematicCompColor(CONNECTOR);
          return <Fragment key={comp}>
            <div
              key={comp}
              className={`sierra-schematic-tree-comp-item`}
              style={{
                left: x * unitSize,
                top: y * unitSize,
                width: width * unitSize,
                height: height * unitSize,
                backgroundColor: color
              }}
            >
              <div className='sierra-schematic-tree-comp-name'>{compName}</div>
            </div>
            {(compItem.pins || []).map((pin) => {
              return <div
                key={`${comp}-${pin.pin}`}
                className={`sierra-schematic-tree-comp-pin`}
                style={{
                  left: pin.x * unitSize,
                  top: pin.y * unitSize,
                }}

              >{pin.pin}</div>
            })}
          </Fragment>
        })}
      </Fragment>
    )
  }
}

const mapState = (state) => {
  const { SierraReducer: { sierra: { sierraInfo, schematicViewInfo, schematicConfig }, project: { verificationId, selectedKeys } } } = state;
  let Interfaces = [];
  if (sierraInfo) {
    Interfaces = sierraInfo.Interfaces || [];
  }
  const { schematicViewPcbList, schematicViewErrorList, schematicViewPCBLogs, schematicDrawPCBLogs } = schematicViewInfo || {}
  return {
    Interfaces,
    verificationId,
    schematicViewPcbList,
    schematicViewErrorList,
    schematicViewPCBLogs,
    schematicDrawPCBLogs,
    selectedDesignIDs: getSelectedDesignIDs(selectedKeys),
    schematicConfig: schematicConfig || {},
  };
}

const mapDispatch = (dispatch) => ({
  _getSchematicViewData(verificationId, info) {
    dispatch(getSchematicViewData(verificationId, info))
  },
  _refreshSchematicViewData(verificationId, pcbId, roots) {
    dispatch(refreshSchematicViewData(verificationId, pcbId, roots))
  },
  _updateSchematicViewPcbStatus(info) {
    dispatch(updateSchematicViewPcbStatus(info))
  },
  _selectChange(obj = {}, designID) {
    dispatch(selectChange(obj, designID))
  },
  changeDisplaySelected(show, designID) {
    dispatch(changeDisplaySelected(show, designID))
  },
  _selectLayer(layers, designID) {
    dispatch(selectLayer(layers, designID))
  },
  _changeShowNameStatus(status, designID) {
    dispatch(changeShowNameStatus(status, designID))
  },
  _updateSchematicConfig(schematicConfig, verificationId) {
    dispatch(updateSchematicConfig(schematicConfig, verificationId))
  }
})

export default connect(mapState, mapDispatch)(SchematicTree);